module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-120x120-18398404ee62031abd19feb66830c23d.png";